module.exports = __webpack_public_path__ + "img/13_K_diamonds.820e56e3.png";